// extracted by mini-css-extract-plugin
export var buttonsWrapper = "SliderControl-module--buttonsWrapper--9b6e1";
export var text = "SliderControl-module--text--ac772";
export var nextButton = "SliderControl-module--nextButton--04454";